import { useState, FormEvent } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: FormEvent) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <footer className="relative bg-[#1B3A2F] text-white py-20">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-4 gap-12 mb-20">
          <div>
            <div className="text-2xl font-bold mb-6">BLUE SKY</div>
            <div className="space-y-2 text-sm text-[#A8B5AF] leading-relaxed">
              <p>Innovative iOS solutions</p>
              <p>Security-first approach</p>
              <p>User-centric design</p>
            </div>
          </div>

          <div>
            <h3 className="text-xs uppercase tracking-wider text-[#A8B5AF] mb-6">NEWSLETTER</h3>
            <form onSubmit={handleNewsletterSubmit} className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="w-full bg-transparent border-b border-[#4A5F54] py-3 pr-10 text-sm text-white placeholder-[#A8B5AF] focus:outline-none focus:border-[#A8B5AF] transition-colors"
              />
              <button 
                type="submit"
                className="absolute right-0 top-3 text-[#A8B5AF] hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </form>
            <p className="text-xs text-[#A8B5AF] mt-4 underline cursor-pointer hover:text-white transition-colors">
              Read our privacy policy
            </p>
          </div>

          <div>
            <h3 className="text-xs uppercase tracking-wider text-[#A8B5AF] mb-6">PRODUCTS</h3>
            <div className="space-y-4">
              <a href="#products" className="block text-sm text-white hover:text-[#A8B5AF] transition-colors">
                VPN Service
              </a>
              <a href="#products" className="block text-sm text-white hover:text-[#A8B5AF] transition-colors">
                Cleaner App
              </a>
              <a href="#products" className="block text-sm text-white hover:text-[#A8B5AF] transition-colors">
                Enterprise Solutions
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xs uppercase tracking-wider text-[#A8B5AF] mb-6">CONNECT</h3>
            <div className="space-y-4">
              <a href="#" className="block text-sm text-white hover:text-[#A8B5AF] transition-colors">
                LinkedIn
              </a>
              <a href="#" className="block text-sm text-white hover:text-[#A8B5AF] transition-colors">
                Twitter
              </a>
              <a href="#" className="block text-sm text-white hover:text-[#A8B5AF] transition-colors">
                GitHub
              </a>
            </div>
          </div>
        </div>

        <div className="mb-12">
          <div className="text-[120px] font-black text-[#D4C4B0] leading-none tracking-tight">
            BLUE SKY
          </div>
        </div>

        <div className="border-t border-[#4A5F54] pt-8">
          <div className="flex flex-wrap items-center gap-8 text-xs text-[#8A9B91]">
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line"></i>
              <span className="uppercase text-[11px]">Address:</span>
              <span className="text-[13px]">Lagjja 16 Prilli, Rruga Llukan Toska, zona kadastrale Nr 8534, FIER 9300, Albania</span>
            </div>
            <div className="w-px h-6 bg-[#4A5F54]"></div>
            <div className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              <span className="uppercase text-[11px]">Email:</span>
              <span className="text-[13px]">info@blueskyshpk.com</span>
            </div>
            <div className="w-px h-6 bg-[#4A5F54]"></div>
            <div className="flex items-center gap-2">
              <i className="ri-phone-line"></i>
              <span className="uppercase text-[11px]">Phone:</span>
              <span className="text-[13px]">+1 6622628343</span>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-[#8A9B91] hover:text-white transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
